<template>
	<el-dialog :visible=is_visible :title="modalLabelHeader" modalClasses="medium-sized-modal" width="30%" @close="hide">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form @submit.prevent="submit" ref="updateStatusForm">
				<b-row>
					<!-- FIELD STATUS NAME -->
					<b-col cols="12">
						<b-form-group label="Status:">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'updateStatus'">

								<!-- {{ updatedStatusVal }} -->
								<b-form-input v-model="form.status" required></b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<!-- FIELD STATUS TYPE -->
					<b-col cols="12">
						<b-form-group label="Status Type:">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'updateGroup'">
								<el-select v-model="form.group" placeholder="Select">
									<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<!-- FIELD MAIN STATUS -->
					<b-col cols="12">
						<b-form-group label="Main Status:" v-if="form.group == 'sub'">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'updateParentId'">
								<el-select v-model="form.parent_id" placeholder="Select">
									<el-option v-for="item in mainStatusOpt" :key="item.status_id" :label="item.status"
										:value="item.status_id">
									</el-option>
								</el-select>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<!-- FIELD TAT DAY -->
					<b-col cols="12" class="mb-0" :class="{ 'mb-0 d-none': form.tat_stop_bool }">
						<b-form-group label="Tat Days:">
							<b-form-input v-model="form.tat_day" type="number" min=0></b-form-input>
						</b-form-group>
					</b-col>
					<b-col cols="12">
						<el-checkbox v-model="form.tat_stop_bool" class="mb-4">Stop TAT Tracking</el-checkbox>
					</b-col>
					<b-col cols="12">
						<el-checkbox v-model="form.is_generate_commission_bool" class="mb-4">Allow
							Generate Commission</el-checkbox>
					</b-col>
					<b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
						<el-button type="primary" native-type="submit" class="w-100" :disabled="invalid" :loading="is_loading">Save</el-button>
					</b-col>
				</b-row>
			</b-form>
		</ValidationObserver>
	</el-dialog>
</template>
<script>
import { Select, Option, Checkbox, Dialog, Button } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import Modal from "@/components/Modal";
import { useProductStore } from '@/stores/productStore'
import { mapActions } from 'pinia'

export default {
	props: ['mainStatusOpt'],
	components: {
		Modal,
		ValidationObserver,
		ValidationProvider,
		[Select.name]: Select,
		[Option.name]: Option,
		[Checkbox.name]: Checkbox,
		[Dialog.name]: Dialog,
		[Button.name]: Button,
	},
	computed: {
		modalLabelHeader(){
			return (!_gHlp.isEmpty(this.originalData)) ? 'Update Mortgage Status' : 'Create Mortgage Status';
		}
	},
	data() {
		return {
			is_loading: false,
			is_visible: false,
			statusOptions: [{
				value: 'main',
				label: 'Main Status'
			}, {
				value: 'sub',
				label: 'Sub Status'
			}],
			originalData: {},
			form: {
				parent_id: '',
				status: '',
				group: 'main',
				tat_day: 0,
				tat_stop: 0,
				tat_stop_bool: false,
				is_generate_commission: 0,
				is_generate_commission_bool: false

			}
		}
	},
	methods: {
		...mapActions(useProductStore, ['createCaseStatus', 'updateCaseStatus']),
		show(item = {}) {
			this.originalData = item;
			if (!_gHlp.isEmpty(item)) {
				this.form = {
					parent_id: _gHlp.getValue(item, 'parent_id'),
					status: _gHlp.getValue(item, 'status'),
					group: _gHlp.getValue(item, 'group', 'main'),
					tat_day: _gHlp.getValue(item, 'tat_day', 0),
					tat_stop: _gHlp.getValue(item, 'tat_stop', 0),
					tat_stop_bool: (_gHlp.getValue(item, 'tat_stop', 0) == 1) ? true : false,
					is_generate_commission: _gHlp.getValue(item, 'is_generate_commission', 0),
					is_generate_commission_bool: (_gHlp.getValue(item, 'is_generate_commission', 0) == 1) ? true : false,
				}
			}

			this.is_visible = true;
		},
		hide(refresh = false) {
			if (refresh) {
				this.$emit('close')
			}
			this.form = {
				parent_id: '',
				status: '',
				group: '',
				tat_day: 0,
				tat_stop: 0,
				tat_stop_bool: false,
				is_generate_commission: 0,
				is_generate_commission_bool: false
			}
			this.is_loading = false;
			this.is_visible = false;
		},
		submit() {
			let formData = {
				status: this.form.status,
				group: this.form.group,
				tat_day: this.form.tat_day,
				tat_stop: this.form.tat_stop_bool == true ? 1 : 0,
				is_generate_commission: this.form.is_generate_commission_bool == true ? 1 : 0,
			}

			if (this.form.group === 'sub') {
				formData.parent_id = this.form.parent_id;
			}
			
			const status_id = _gHlp.getValue(this.originalData, 'status_id', null)
			this.is_loading = true;
			if (!_gHlp.isEmpty(status_id)) {
				this.updateCaseStatus('status-mortgage', status_id, formData).then(resp => {
					_gNotif.notifySuccess('<b>Status</b> - Successfully Updated.')
					this.hide(true)
				}).catch(err => {
					_gNotif.errorFunction(err)
					this.is_loading = false
				})

			} else {
				this.createCaseStatus('status-mortgage', formData).then(resp => {
					console.log(resp);
					_gNotif.notifySuccess('<b>Status</b> - Successfully Created.')
					this.hide(true)
				}).catch(err => {
					_gNotif.errorFunction(err)
					this.is_loading = false
				})
			}
		},
	}
}
</script>